export default o => (
  Object.keys(o).forEach(k => !o[k] && o[k] !== 0 ? delete o[k] : '') || o
)
